// extracted by mini-css-extract-plugin
export var black = "_2s-6";
export var brand = "_2s-1";
export var ddefault = "_2s-0";
export var error = "_2s-3";
export var gray = "_2s-2";
export var highContrast = "_2s-8";
export var outline = "_2s-7";
export var success = "_2s-5";
export var warning = "_2s-4";